<script lang="ts" setup>
import { buildDocumentCompareOptions } from "~/utils/document-compare-options";

const documentId = inject("documentId") as any;

const documentToCompareStore = useDocumentToCompareStore(documentId);
const { documentIdToCompare, hasDocumentToCompare, documentsToCompare } =
  storeToRefs(documentToCompareStore);

const compareOptions = computed(() =>
  buildDocumentCompareOptions(documentsToCompare.value, documentId)
);

const selectedOption = computed(() =>
  compareOptions.value.options.find((option) => option.value === documentIdToCompare.value)
);
</script>

<template>
  <div class="h-full w-full flex flex-col">
    <div class="p-4 flex flex-row shrink-0 border-b">
      <BaseSelectInput
        v-model="documentIdToCompare"
        placeholder="Select a document to compare"
        :options="compareOptions.options"
        :grouped-options="compareOptions.groups"
        :are-options-grouped="true"
        value-prop="value"
        label="label"
        :searchable="true"
      >
        <template #option="{ option }">
          <div
            class="option-contents flex min-w-0 flex-col gap-0.5 rounded px-2 py-2 text-input-1 cursor-pointer select-none"
            :class="{ 'bg-primary/10': option.value === documentIdToCompare }"
          >
            <span class="w-full truncate leading-5" :title="option.name">{{ option.name }}</span>
            <span class="flex items-center gap-1.5 text-[11px] leading-4">
              <span class="font-medium text-warning-default">{{ option.typeLabel }}</span>
              <span v-if="option.dateLabel" aria-hidden="true" class="text-medium/60">·</span>
              <span class="text-medium" :title="option.dateTitle">{{ option.dateLabel }}</span>
            </span>
          </div>
        </template>
        <template #singlelabel>
          <span v-if="selectedOption" class="flex min-w-0 flex-col gap-0.5 text-left">
            <span class="truncate leading-5" :title="selectedOption.name">{{ selectedOption.lesson }} · {{ selectedOption.name }}</span>
            <span class="flex items-center gap-1.5 text-[11px] leading-4">
              <span class="font-medium text-warning-default">{{ selectedOption.typeLabel }}</span>
              <span v-if="selectedOption.dateLabel" aria-hidden="true" class="text-medium/60">·</span>
              <span class="text-medium" :title="selectedOption.dateTitle">{{ selectedOption.dateLabel }}</span>
            </span>
          </span>
        </template>
      </BaseSelectInput>
    </div>
    <div class="grow min-h-0 overflow-auto pt-2">
      <DocumentWrapper
        v-if="hasDocumentToCompare && documentIdToCompare"
        :key="documentIdToCompare"
        :document-id="documentIdToCompare"
        :mode="DocumentViewMode.compare"
        class="document-compare-container"
      />
    </div>
  </div>
</template>

<style scoped></style>
